import React, { FC } from "react";
import { ModalDialog } from "../../../../components";
import { API_URL_ORDER } from "../../../../checkout/api";
import * as Ajax from "../../../Ajax";

interface InvalidOrderModalProps {
    onClickUrlOverride?: () => void;
}

const InvalidOrderModal: FC<InvalidOrderModalProps> = ({ onClickUrlOverride }) => {
    function deleteCookieAndSendUserToStartpage() {
        Ajax.remove({ url: API_URL_ORDER })
            .then(() => {
                window.location.href = "/";
            })
            .catch(() => {
                window.location.href = "/";
            });
    }

    function continueClicked(e: React.MouseEvent<HTMLButtonElement>) {
        if (onClickUrlOverride) return;
        e.preventDefault();
        deleteCookieAndSendUserToStartpage();
    }

    return (
        <ModalDialog
            size="medium"
            submitText="Fortsett"
            closeText="Lukk"
            heading="Ups, der skjedde det noe..."
            name="invalid-order-modal"
            onSubmit={continueClicked}
            onClose={deleteCookieAndSendUserToStartpage}
        >
            Du har produkter i handlekurven som ikke er tilgjengelig lengre. Handlekurven vil bli tømt slik at du kan
            starte på nytt.
        </ModalDialog>
    );
};

export default InvalidOrderModal;
